export default "__VITE_ASSET__Df90aX$N__"